// Silenciar logs do console no navegador para manter o F12 limpo, seguro e performático
console.log = () => {};
console.info = () => {};
console.warn = () => {};
console.debug = () => {};
console.error = () => {};

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
